// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__vnIt5","options_box":"SearchBar_options_box__H6WDS"};